import React, { useState, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import Inputbox from "../Component/Inputbox";
import { BiSolidHide, BiShow } from "react-icons/bi";
import Button from "../Component/Button";
import { showToast } from "../helper/Toster";
import REACT_APP_API_URL from "../utils/constant.js";
import Logo from "../assets/Image/logo.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState(""); // Validation error for email
  const [passwordError, setPasswordError] = useState(""); // Validation error for password

  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };
  useEffect(() => {
    localStorage.removeItem("user");
    if (localStorage.getItem("user")) {
      navigate("/login");
    }
  });

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form submission from reloading the page

    // Reset error messages before validating
    setEmailError("");
    setPasswordError("");

    // Validate email and password fields
    let valid = true;
    if (email.trim() === "") {
      setEmailError("Please enter your email.");
      valid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex
      const isValidate = emailRegex.test(email);
      if (!isValidate) {
        setEmailError("Please enter a valid email.");
        valid = false;
      }
    }

    if (!password.trim()) {
      setPasswordError("Please enter your password.");
      valid = false;
    }

    if (!valid) {
      return; // Stop further processing if validation fails
    }
    try {
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>hi");
      let result = await fetch(`${REACT_APP_API_URL}login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
        }),
      });
      result = await result.json();
      console.log(result);
      if (result && result.code === 200) {
        showToast("success", "Login Successfully");
        localStorage.setItem("user", result.data);
        navigate("/dashboard");
      }
      if (result && result.code === 404) {
        showToast("error", "Invalid Email..");
        // alert("");
      }
      if (result && result.code === 401) {
        console.log("ssss");

        showToast("error", "Invalid password..");
        // alert("Invalid password");
      }
    } catch (err) {
      console.log(err);
      alert("Error while logging in");
    }
  };

  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner">
          <div className="card px-sm-6 px-0">
            <div className="card-body">
              <div className="mb-4 text-center">
                <img src={Logo} alt="" height={120} />
              </div>
              <h4 className="mb-6 text-center">Welcome to Goose! 👋</h4>

              <form
                id="formAuthentication"
                className=" fv-plugins-bootstrap5 fv-plugins-framework"
                action="/dashboard"
                method=""
              >
                <div className="mb-3">
                  <label
                    htmlFor="email"
                    className="form-label font-bold fw-semibold"
                  >
                    Email
                  </label>
                  <Inputbox
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} // Ensure full event is passed
                    placeholder="Enter your email address"
                    className="form-control"
                  />
                  {emailError && (
                    <div className="text-danger mt-1">{emailError}</div> // Show email error message below the input
                  )}
                </div>
                <div className="mb-3 position-relative">
                  <label htmlFor="password" className="form-label fw-semibold">
                    Password
                  </label>
                  <Inputbox
                    type={isPasswordVisible ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)} // Ensure full event is passed
                    placeholder="Enter your password"
                    className="form-control"
                  />
                  {passwordError && (
                    <div className="text-danger mt-1">{passwordError}</div> // Show password error message below the input
                  )}
                  <div
                    className="password-show position-absolute"
                    onClick={togglePasswordVisibility}
                  >
                    {isPasswordVisible ? <BiShow /> : <BiSolidHide />}
                  </div>
                </div>

                <div className="mb-5">
                  <div className="d-flex justify-content-between">
                    <NavLink to="/forgotpassword">
                      <span>Forgot Password?</span>
                    </NavLink>
                  </div>
                </div>
                <div className="">
                  <Button className="w-100" onClick={handleLogin} type="button">
                    Login
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
